var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datepicker',{attrs:{"name":"date","inline":false,"placeholder":"Select Date","cleared":() => { this.selectedTemp = null },"disabled-dates":_vm.disabledDates},model:{value:(_vm.selectedTemp),callback:function ($$v) {_vm.selectedTemp=$$v},expression:"selectedTemp"}})
}
var staticRenderFns = []

export { render, staticRenderFns }